var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFtt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 256,
    viewBox: "0 0 257 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 256C198.694 256 256 198.694 256 128C256 57.3056 198.694 0 128 0C57.3056 0 0 57.3056 0 128C0 198.694 57.3056 256 128 256ZM91.8374 61.4497C131.617 61.4368 171.401 61.4368 211.186 61.4497C211.199 75.1507 211.199 88.8493 211.186 102.546C171.405 102.559 131.621 102.559 91.8374 102.546C91.8246 88.8445 91.8246 75.146 91.8374 61.4497ZM83.3544 118.006C70.5158 117.935 57.6793 117.935 44.845 118.006C44.7784 131.686 44.7784 145.364 44.845 159.041C57.6798 159.109 70.5163 159.108 83.3544 159.037C83.421 145.358 83.421 131.681 83.3544 118.006ZM91.8656 118.006C120.58 117.94 149.29 117.94 177.999 118.006C178.061 131.681 178.061 145.358 177.999 159.037C149.286 159.101 120.576 159.101 91.8656 159.037C91.8067 145.362 91.8067 131.685 91.8656 118.006ZM130.333 174.575C117.526 174.427 104.716 174.427 91.9027 174.575C91.7734 188.228 91.776 201.875 91.9091 215.517C104.717 215.657 117.527 215.658 130.34 215.524C130.469 201.868 130.467 188.219 130.333 174.575Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtt);
export default __webpack_public_path__ + "static/media/ftt.aa38f327.svg";
export { ForwardRef as ReactComponent };